import BlogFeaturedPost from "./BlogFeaturedPost";
export default BlogFeaturedPost;
